import {createSelector} from 'reselect'

const selectform = state => state.form;

export const selectFormPeriod = createSelector(
    [selectform],
    form => form.period
);

export const selectFormPortal = createSelector(
    [selectform],
    form => form.portal
);
export const selectHoldOverForm = createSelector(
    [selectform],
    form => form.HoldOver
);
export const selectLastPrice = createSelector(
    [selectform],
    form => form.lastPrice
);
export const selectReceivedForm = createSelector(
    [selectform],
    form => form.receivedForm
);

export const selectReceivedExcel = createSelector(
    [selectform],
    form => form.receivedExcel
);



